const _dwmData = {
    alertsDetails: {},
    statusApi: {},
};

const observableCryptoData = new Rx.BehaviorSubject(_dwmData);

const dwmRepository = {

    getAll(key) {

        return key ? _dwmData[key] : _dwmData;

    },

    replace(key, data) {

        if (key) {

            _dwmData[key] = data;

        }

        if (data.primaryMember) {

            if (Object.keys(data.primaryMember.primaryAddress).length > 0) {

                const addresses = data.primaryMember.monitoredAccounts.addresses.entries;
                const primaryAddresses = data.primaryMember.primaryAddress;

                const hasPrimaryAddress =
                    addresses.find(address => address.street1 === primaryAddresses.street1 &&
                        address.city === primaryAddresses.city &&
                        address.postalCode === primaryAddresses.postalCode);

                if (!hasPrimaryAddress) {

                    data.primaryMember.monitoredAccounts.addresses.entries
                        .unshift(data.primaryMember.primaryAddress);

                }

            }

            if (Object.keys(data.primaryMember.primaryPhone).length > 0) {

                const numbers = data.primaryMember.monitoredAccounts.phoneNumbers.entries;
                const primaryNumber = data.primaryMember.primaryPhone;

                const hasPrimaryPhone =
                    numbers.find(number => number.phoneNumber === primaryNumber.phoneNumber);

                if (!hasPrimaryPhone) {

                    data.primaryMember.monitoredAccounts.phoneNumbers.entries
                        .unshift(data.primaryMember.primaryPhone);

                }

            }

            this.updateCardStatus(data.primaryMember);

        }

        observableCryptoData.onNext(_dwmData);

    },

    updateAlertsDetails(key, value) {

        if (key) {

            _dwmData.alertsDetails[key] = value;

        }

        observableCryptoData.onNext(_dwmData);

    },

    updateCardStatus(data) {

        const monitoredAssets = Object.keys(data.monitoredAccounts)
            .filter(asset => data.monitoredAccounts[asset].entries.length > 0);

        if (monitoredAssets.length === 0) {

            data.dwmCardStatus = 'add-more-data';

        }

    },

    getObservable() {

        return observableCryptoData;

    },

};

export default dwmRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.dwmRepository.js